import { render, staticRenderFns } from "./Feedbackpage.vue?vue&type=template&id=1bf8b5f8&scoped=true"
import script from "./Feedbackpage.vue?vue&type=script&lang=js"
export * from "./Feedbackpage.vue?vue&type=script&lang=js"
import style0 from "./Feedbackpage.vue?vue&type=style&index=0&id=1bf8b5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8b5f8",
  null
  
)

export default component.exports